import { Spin } from 'antd';
import { SpinSize } from 'antd/es/spin';

import styles from './Spin.module.scss';

interface Props {
    size?: SpinSize;
}

export const Spinner = ({ size = 'large' }: Props) => {
    const indicator = <span role="img" aria-label="loading"></span>;
    return (
        <Spin
            className={styles.loading}
            indicator={indicator}
            size={size}
        ></Spin>
    );
};
